<app-e-form-viewer id="eFormViewer" 
    *ngIf="showViewer" 
    [configInput]="config" 
    [masterId]="masterId"
    [designPageIndex]="customPageIndex"
    (renderCompleted)="renderCompleted()">
</app-e-form-viewer>